module Client.Admin.EnableUser.Enable

open Shared
open Client
open Illy.SafeStack.Client
open Fable.React 
open Fable.React.Props 
open Shared.Admin.EnableUser

type Model = 
    {
        UserId: UserId 
        GeneralError: string option
        Saving: bool
    }

module Validations = 
    open Illy.SafeStack.Validation
    open Illy.SafeStack.CompositionalValidation
    open Shared.Admin.EnableUser.Validations

    let resetValidations (m: Model) = 
        {m with 
            GeneralError = None
        }

    let dispatchValidations model = 
        let model = resetValidations model 
        function 
        | ValidationResult.Passed -> model 
        | ValidationResult.Warned _ -> failwith "Did not expect warnings"
        | ValidationResult.Failed (err, _) ->
            let errors = List.map EnableValidations.toString err 
            {model with GeneralError = concatOptional errors}

type Msg = 
    | ApiError of ApiError
    | SaveResult of FailureReason option
    | CloseOverlay  
    | SaveClicked 


type Event = 
    | CloseOverlay 
    | ApiError of ApiError 
    | SaveSuccessful of notification: string 

let init userId = 
    {
        UserId = userId 
        GeneralError = None
        Saving = false
    }, []

let update msg model = 
    match msg with 
    | Msg.ApiError err -> model, err |> ApiError |> SideEffect.Event 
    | Msg.CloseOverlay -> model, CloseOverlay |> SideEffect.Event 
    | SaveClicked -> 
        {model with Saving = true},
        Api.secureCall<IEnableUserApi,_,_,_> SecuredRoute.Admin (fun api -> api.enable) model.UserId SaveResult Msg.ApiError
        |> SideEffect.Cmd
    | SaveResult reason -> 
        match reason with 
        | None
        | Some NothingToDo -> model, "User was enabled successfully." |> Event.SaveSuccessful |> SideEffect.Event
        | Some (FailedValidations v) ->
            Validations.dispatchValidations {model with Saving = false} v, SideEffect.none

let view model dispatch = 
    jQueryUI.modal "Do you want to re-enable the user?" 50 Msg.CloseOverlay dispatch (Some 800) [
        yield p [] [
            str "Re-enabling a user will require a spare license."
            br []
            str "Note: any application-specific configuration of the user, e.g. role-based security, will need to be re-applied."
        ]
        yield UI.renderError model.GeneralError
        yield! UI.saveControls (Some "Enable User") false model.Saving SaveClicked Msg.CloseOverlay dispatch
    ]